import PropTypes from 'prop-types';
import { forwardRef, memo } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Collapse from 'shopper/components/Collapse';
import Heading from 'shopper/components/Heading';

import { isLastItem } from 'lib/array';
import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

const RULES = [
  {
    title: 'Seja Amigável',
    text: 'Não seja ofensivo com ninguém.',
  },
  {
    title: 'Comunique-se de forma clara',
    text: 'Faça-se ser entendido explicando bem com o seu tópico o que você deseja.',
  },
  {
    title: 'Evite conteúdo duplicado',
    text: 'Confira se já há um tópico igual ou semelhante antes de criar o seu.',
  },
  {
    title: 'Compartilhe ofertas no lugar certo',
    text: 'Ofertas, apenas na área de ofertas.',
  },
  {
    title: 'Use a Lista de Desejos',
    text: 'Nada de pedir para ser avisado, use a Lista de Desejos e configure seus próprios alertas.',
  },
  {
    title: 'Respeite os termos da comunidade',
    text: 'Não viole os Termos de Uso do Promobit ou as Diretrizes da Comunidade.',
  },
  {
    title: 'Autopromoção e anúncios',
    text: 'Não faça autopromoção nem divulgue qualquer anúncio no Fórum.',
  },
  {
    title: 'Serviços de terceiros e lojas confiáveis',
    text: 'Comente apenas de ofertas que apareceram no Promobit e não pergunte se uma loja é confiável.',
  },
  {
    title: 'Contenha as expectativas',
    text: 'Infelizmente a comunidade não tem como prever promoções ou preços, por isso não são aceitos posts do tipo "por quanto deve aparecer produto X em dezembro?"',
  },
];

const SidebarRules = forwardRef(
  ({ className, gaEventCategory = null, ...rest }, ref) => (
    <Box ref={ref} className={twMerge('mb-4 p-4', className)} full {...rest}>
      <Heading as="span" className="mb-4" size="size6">
        {placeholder('titles.forumRules')}
      </Heading>
      {RULES.map(({ title, text }, index, arr) => (
        <Collapse
          key={title}
          className={!isLastItem(arr, index) && 'mb-2'}
          data-test-selector="open-forum-rule"
          headerProps={{
            onClick: (_, isOpen) => {
              if (gaEventCategory) {
                sendEvent({
                  gaEventCategory,
                  action: isOpen ? 'accordion_close' : 'accordion_open',
                });
              }
            },
          }}
          title={`${index + 1}. ${title}`}
          full
        >
          {text}
        </Collapse>
      ))}
    </Box>
  )
);

SidebarRules.displayName = 'SidebarRules';

SidebarRules.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string,
};

export default memo(SidebarRules);
